<template>
	<vxe-modal v-model="showFlag" title="站点链接情况" :mask="false":lock-view="false" show-zoom resize
						:destroy-on-close="true" fullscreen remember :esc-closable="true">
			<div class="actDiv">
				<label style="font-size: 0.8rem;">给水号：</label>
				<a-input style="width: 10.5rem;" v-model="theApid" ></a-input>
				<label style="font-size: 0.8rem;margin-left: 0.625rem;">状态：</label>
				<a-select style="width:6.5rem;  font-size: 0.6875rem;" v-model="theStatus"  >
					<a-select-option v-for="item in statusList" :key="item.index" :value="item.index">
						{{item.name}}
					</a-select-option>
				</a-select>
				<a-button size="small"   icon="search" @click="queryData()" style="margin: 0 0.5rem;" :loading="loading">查询</a-button>
				<a-button size="small"   icon="download" @click="exportData()" style="margin: 0 0.5rem;" :loading="loading">导出</a-button>
			</div>
			<a-table  size="small" :columns="columns" :data-source="dataList" bordered :loading="loading"
							rowKey="id" :pagination="false" :scroll="{y:600}" :hideOnSinglePage="false">
				<span slot="statusSlot" slot-scope="text, record" :style="getTheLinkStatusStyle(record.meterStatus)">
					{{getMeterStatus(record.meterStatus)}}
				</span>
			</a-table>
	</vxe-modal>
</template>

<script>
	const columns = [
		{
			title: '给水号',
			dataIndex: 'meterApid',
			width:120,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '表地址',
			dataIndex: 'meterAddr',
			width:140,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '监控点名称',
			dataIndex: 'monitorName',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '监控点地址',
			dataIndex: 'monitorAddress',
			width:240,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '口径',
			dataIndex: 'caliber',
			width:90,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '表读数',
			dataIndex: 'readData',
			width:110,
			className:'v-cell',
			align:'center',
		},
		{
			title: '电压',
			dataIndex: 'voltage',
			width:70,
			className:'v-cell',
			align:'center',
		},
		{
			title: '最后接收时间',
			dataIndex: 'readTime',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '未链接天数',
			dataIndex: 'noLinkDays',
			width:160,
			ellipsis:true,
			className:'v-cell',
			align:'center',
		},
		{
			title: '状态',
			dataIndex: 'meterStatus',
			width:100,
			className:'v-cell',
			scopedSlots:{customRender:'statusSlot'},
			align:'center',
		}
		
	];
	export default {
		data(){
			return {
				columns,
				dataList:[],
				loading:false,
				showFlag:false,
				theApid:'',
				theStatus:'2',
				statusList:[
					{
						index:'2',
						name:'全部'
					},
					{
						index:'0',
						name:'未链接'
					},
					{
						index:'1',
						name:'已链接'
					},
				],
			}
		},
		methods:{
			getTheLinkStatusStyle(status){
				if(status == '1'){
					return {
						color:"#000000",
					}
				}else{
					return {
						color:"#FF0000",
					}
				}
			},
			getMeterStatus:function(status){
				if(status == '1'){
					return "已链接";
				}else{
					return "无链接";
				}
			},
			showView(){
				this.showFlag = true;
				this.queryData();
			},
			queryData(){
				this.loading = true;
				let param = {
					theStatus:this.theStatus,
					apId:this.theApid,
				}
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_LINK_STATUS_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			exportData(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_LINK_EXPORT_URL);
				let param = {
					theStatus:this.theStatus,
					apId:this.theApid,
				}
				this.Api.fetchPostFile(url,param).then((res)=>{
					this.loading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '站点链接情况'+'.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
		},
	}
</script>

<style>
</style>
